/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SAL_AI_REPORTS_ITEM = {
  id: 'sales_ai_reports',
  screenId: 'met-sal-ai-reports',
  label: 'Informes IA',
  description: 'Informes automáticos de ventas y productos generados con inteligencia artificial.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Pedís un informe escrito que analiza ventas y productos de un período. La IA resume números reales de tu empresa, destaca lo importante y sugiere acciones concretas (precios, surtido, clientes, etc.).',
      },
      {
        title: 'Antes de empezar',
        bullets: [
          'Necesitás ventas facturadas en el período elegido; si no hay, el sistema avisa y no genera el informe.',
          'Solo puede haber un informe en proceso a la vez. Esperá a que termine antes de pedir otro.',
          'El rango de fechas no puede superar un año.',
        ],
      },
      {
        title: 'Paso 1 — Generar informe',
        bullets: [
          'Elegí el período con los atajos (Hoy, Semana, Mes, Mes anterior) o Personalizado (desde / hasta + Aplicar).',
          'Tocá «Generar informe IA». El proceso tarda unos minutos y corre en segundo plano.',
          'Podés salir de esta pantalla y seguir trabajando: el informe queda guardado y no se pierde.',
          'Si tenés notificaciones activadas, recibirás un aviso cuando esté listo.',
        ],
      },
      {
        title: 'Paso 2 — Informes guardados',
        bullets: [
          'La lista muestra cada informe con su período, fecha de solicitud y estado: En cola, Generando…, Listo o Error.',
          'Mientras hay uno en proceso, la lista se actualiza sola cada pocos segundos.',
          'Cuando está Listo, tocá «Ver informe» para abrirlo.',
        ],
      },
      {
        title: 'Paso 3 — Leer el informe',
        bullets: [
          'Resumen ejecutivo — panorama general del período.',
          'Destacados — puntos positivos, negativos o neutros.',
          'Gráficos — evolución, rankings y tortas según los datos del período.',
          'Análisis detallado — secciones como panorama, tendencia, productos, clientes y rentabilidad.',
          'Recomendaciones — acciones sugeridas con el motivo.',
          'Riesgos y notas sobre los datos — limitaciones o datos incompletos (por ejemplo, márgenes sin costo).',
          'Tocá «← Volver al listado» para regresar.',
        ],
      },
    ],
  },
}
